import { t } from "ttag";

import { useOnboardingStore } from "@/features/onboarding/stores";
import { CATEGORY_SLUG } from "@/shared/domains";
import { DetailCard, Heading, MarkdownContent } from "@/shared/ui";

export const CHECKOUT_ID = "checkout";

export const SelectedProduct = () => {
  const product = useOnboardingStore(
    (state) =>
      state.selectedCategories.find(
        (category) => category.slug === CATEGORY_SLUG.WEIGHT_LOSS,
      )?.selectedProduct,
  );

  if (!product) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3" id={CHECKOUT_ID}>
      <Heading level={2} size="large" color="primary" align="center">
        {t`Currently chosen`}:{" "}
        <span className="text-secondary-500">{product.name}</span>
      </Heading>

      <DetailCard.Root
        variant="borderLess"
        className="flex-row gap-2.5 border border-neutral-100 p-4 sm:gap-4 md:p-5"
      >
        <div className="flex grow flex-col gap-1">
          <Heading size="xx-small" level={3}>
            {product.name}
          </Heading>

          <DetailCard.Description
            className="line-clamp-2 text-sm text-neutral-700"
            title={product.description}
          >
            <MarkdownContent>{product.description}</MarkdownContent>
          </DetailCard.Description>
        </div>

        <DetailCard.Thumbnail
          src={product.thumbnail ?? "#"}
          className="-my-5 -mr-5 h-auto w-full max-w-26"
        />
      </DetailCard.Root>
    </div>
  );
};
